import React from 'react'
import { graphql } from 'gatsby'
import Container from '../components/container'
import ContactDemo from '../components/contact/contact-demo'
import GraphQLErrorList from '../components/graphql-error-list'
import PageIntro from '../components/page/page-intro2'
import FeaturePreviewGrid from '../components/feature/feature-preview-grid'
import UspPreviewGrid from '../components/usp/usp-preview-grid'
import SEO from '../components/seo'
import * as styles from '../styles/pages.module.css'
import * as typo from '../components/typography.module.css'
import Layout from '../containers/layout'
import { PropTypes } from 'prop-types'
import { Excerpt } from '../components/content/Excerpt'
import PagePreviewGrid from '../components/page/page-preview-grid'


export const query = graphql`query ProjectsPageQuery2 {
  projects: allSanityProject(limit: 3, sort: {publishedAt: DESC}) {
    edges {
      node {
        id
        mainImage {
          asset {
            _id
          }
          alt
        }
        title
        _rawExcerpt
        slug {
          current
        }
      }
    }
  }
  landing: sanityLanding(slug: {current: {eq: "product"}}, mainImage: {asset: {}}) {
    id
    title
    subtitle
    excerpt
    _rawBody
    mainImage {
      asset {
        _id
      }
    }
    pageentries {
      id
      title
      excerpt
      slug {
        current
      }
    }
    usps {
      title
      subTitle
      linkText
      linkUrl
      _rawExcerpt
      _rawBullets
      style {
        color
        title
      }
      mainImage {
        alt
        asset {
          _id
        }
      }
      _id
    }
    relatedFeatures {
      title
      _rawExcerpt
      id
      title
      mainImage {
        asset {
          _id
        }
        alt
      }
      slug {
        current
      }
    }
  }
}`

const ProjectsPage = props => {
  const { data, errors } = props
  const landing = (data || {}).landing


  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    )
  }
  const uspNodes = (data || {}).landing.usps
  const pageNodes = (data || {}).landing.pageentries
  const featureNodes = (data || {}).landing.relatedFeatures

  const highlightedUsp = uspNodes?.slice(0, 1)
  const firstUsp = uspNodes?.slice(1, 4)
  const secondUsps = uspNodes?.slice(4)


  return (
    <Layout
      textColor="#032821"
      backgroundColor="#FDF3F3"
    >

      <PageIntro
        title={landing.title}
        excerpt={landing.excerpt}
        product={true}
        subtitle={landing.subtitle}
        backgroundImage={landing.mainImage}
        backgroundColor="#FDF3F3"
        textColor="#032821"
      />

      <SEO title='Product' />


      <Container>
        <Excerpt excerpt={landing.excerpt} />
        {highlightedUsp && highlightedUsp.length > 0 &&
        <UspPreviewGrid style="productFeatured" nodes={highlightedUsp} />}
        {firstUsp && firstUsp.length > 0 && <UspPreviewGrid nodes={firstUsp} />}
      </Container>
      {featureNodes && featureNodes.length > 0 &&
        <div style={{ backgroundColor: '#FDF3F3' }}>
          <Container>
            <FeaturePreviewGrid
              nodes={featureNodes}
              title="Core features"
              browseMoreHref=""
            />
          </Container>
        </div>
      }
      <Container>

        {secondUsps && secondUsps.length > 0 && <UspPreviewGrid nodes={secondUsps} />}

        {pageNodes && pageNodes.length > 0 && (
          <PagePreviewGrid
            title='Learn more'
            itemColor='#F9F9F9'
            pages={pageNodes} />
        )}
      
      </Container>
      <Container fullwidth backgroundColor={'#DBE8EB'}>
          <ContactDemo title={'Mer enn 200 organisasjoner bruker allerede Dignio til å følge opp tusener av pasienter hver måned, bli med dere og'} subtitle={'Book en demo'} />
      </Container>
    </Layout>
  )
}
ProjectsPage.propTypes = {
  data: PropTypes.object,
  errors: PropTypes.array,
}

export default ProjectsPage
